export default {
  'shippingOptions.list.newShipment': 'Criar novo envio',
  'shippingOptions.list.title': 'Título',
  'shippingOptions.list.subject': 'Assunto',
  'shippingOptions.list.action': 'Ação',

  'shippingOptions.remove': 'Remover opção de envio',
  'shippingOptions.remove.alert':
    'Você realmente deseja remover a opção de envio:',
  'shippingOptions.remove.notification.success': 'Sucesso',
  'shippingOptions.remove.notification.successDescription':
    'Opção de envio removido',

  'shippingOptions.emailMontage.title': 'Título',
  'shippingOptions.emailMontage.company': 'Empresa',
  'shippingOptions.emailMontage.subject': 'Assunto',
  'shippingOptions.emailMontage.quiz': 'Questionário',

  'shippingOptions.buttons.next': 'Salvar e continuar',
  'shippingOptions.buttons.finish': 'Finalizar',
};
